/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Button,
} from 'reactstrap';

import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { get, post } from '../../helpers/api_helper';
import TagSelector from '../Common/TagSelector';

function CategoryTagGroups(props) {
  const {
    t,
    categoryId,
    onSuccess,
  } = props;

  const [entity, setEntity] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getEntity = async () => {
    try {
      setLoading(true);

      const obj = await get(`/api/listings/category/${categoryId}`);
      setEntity(obj);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const editCategory = async (id, data) => {
    try {
      await post(`/api/listings/category/${id}/save`, data);
      setError(null);
    } catch (err) {
      setError(`${err.message}: ${err.response.data}`);
    }
  };

  useEffect(() => {
    getEntity();
  }, []);

  return (
    <div>
      {entity !== null && (
        <Formik
          enableReinitialize
          initialValues={{ id: entity.id, tagGroups: entity.tagGroups }}
          validationSchema={Yup.object().shape({
            id: Yup.number().required(t('Category is required')),
            tagGroups: Yup.array().of(Yup.object().shape({
              id: Yup.number(),
              tags: Yup.array().of(Yup.object().shape({
                id: Yup.number(),
                label: Yup.string(),
              })),
            })),
          })}
          onSubmit={async (data) => {
            const resp = await editCategory(data.id, data); onSuccess(resp);
          }}
        >
          {({
            touched, errors, values, setFieldValue,
          }) => (
            <Form className="mt-3" autoComplete="off" id="cat_tag_groups">
              <div className="mb-3" style={{ minHeight: '20px' }}>
                <Button color="primary" size="sm" className="float-end" onClick={() => { setFieldValue(`tagGroups[${values.tagGroups.length}]`, { tags: [] }); }}>
                  <span className="mdi mdi-plus" />
                  {t('Add Tag Group')}
                </Button>
                <p>{t('Matching tags')}</p>
              </div>
              {values.tagGroups.map((x, i) => (
                <div className="mt-2 mb-2">
                  <Button color="danger" size="sm" className="float-end ms-2 mt-2" onClick={() => { setFieldValue('tagGroups', values.tagGroups.filter((_, y) => y !== i)); }}><span className="mdi mdi-close-thick" /></Button>
                  <TagSelector initialTags={x.tags} onUpdate={(tags) => { setFieldValue(`tagGroups[${i}].tags`, tags); }} id={`tag_select_${i}`} />
                </div>
              ))}
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
}

CategoryTagGroups.defaultProps = {
  t: (x) => (x),
  categoryId: 0,
  onSuccess: () => {},
};

CategoryTagGroups.propTypes = {
  t: PropTypes.any,
  categoryId: PropTypes.number,
  onSuccess: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(CategoryTagGroups));
